import PitchCall from "../../enums/PitchCall.js";

const classifiesAsPitch = function(pitchCall) {
    switch (pitchCall) {
        case PitchCall.Ball.key:
        case PitchCall.CalledStrike.key:
        case PitchCall.SwingingStrike.key:
        case PitchCall.BallInPlay.key:
        case PitchCall.FoulBall.key:
        case PitchCall.FoulBunt.key:
        case PitchCall.FoulTip.key:
        case PitchCall.HitByPitch.key:
        case PitchCall.IntentionalBall.key:
        case PitchCall.PitchOut.key:
        case PitchCall.IllegalPitch.key:
        case PitchCall.Unidentified.key: // NOTE - unidentified pitch is assumed to be regular pitch, as these are quite rare
            return true;

        default:
            return false;
    }
};

export default classifiesAsPitch;